import { useEffect, useRef, useState } from "react";
import {
  Button,
  Input,
  InputGroup,
  InputRightAddon,
  useClipboard,
  VStack,
} from "@chakra-ui/react";
import BookingModal from "../../PhotographerDetail2"; // ✅ Booking Component
import LoginModal from "../../LoginModal"; // ✅ Login Component
import OnboardingModal from "../../Onboarding"; // ✅ Onboarding Component

export default function Actions({ isEditable, userData }) {
  const [isBookingOpen, setIsBookingOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isOnboardingOpen, setIsOnboardingOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token")); // ✅ Track login state

  console.log("USER DATE", userData)
  const handleBookNow = () => {
    if (isLoggedIn) {
      setIsBookingOpen(true); // ✅ Open Booking Modal if logged in
    } else {
      setIsLoginOpen(true); // ✅ Open Login Modal if NOT logged in
    }
  };

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setIsBookingOpen(true); // ✅ Open Booking Modal immediately after login
  };

  const handleOpenOnboarding = () => {
    setIsLoginOpen(false); // Close login modal
    setIsOnboardingOpen(true); // Open onboarding modal
  };

  // Profile link sharing
  const value = `https://${window.location.hostname}/user/${userData.id}`;
  const { hasCopied, onCopy } = useClipboard(value);
  const profileUrl = useRef(null);

  useEffect(() => {
    if (hasCopied) {
      profileUrl.current.focus();
      profileUrl.current.select();
    }
  }, [hasCopied]);

  return (
    <VStack py={8} px={5} spacing={3}>
      {/* ✅ Book Now Button */}
      <Button w="full" colorScheme="purple" size="lg" onClick={handleBookNow}>
        Book Now
      </Button>

      {/* ✅ Booking Modal (Only opens if logged in) */}
      {isBookingOpen && (
        <BookingModal
          photographer={userData}
          isOpen={isBookingOpen}
          onClose={() => setIsBookingOpen(false)}
        />
      )}

      {/* ✅ Login Modal (Opens if NOT logged in) */}
      <LoginModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        setIsLoggedIn={setIsLoggedIn}
        onLoginSuccess={handleLoginSuccess}
        onSignUp={handleOpenOnboarding} // ✅ Handle Sign Up Click
      />

      {/* ✅ Onboarding Modal (Opens if user clicks Sign Up) */}
      <OnboardingModal
        isOpen={isOnboardingOpen}
        onClose={() => setIsOnboardingOpen(false)}
        setIsLoggedIn={setIsLoggedIn}
      />

      {/* ✅ Profile Link (For sharing) */}
      <InputGroup>
        <Input
          ref={profileUrl}
          type="url"
          color="brand.blue"
          value={value}
          userSelect="all"
          isReadOnly
          _focus={{ borderColor: "brand.blue" }}
        />
        <InputRightAddon bg="transparent" px={0} overflow="hidden">
          <Button onClick={onCopy} variant="link">
            <svg width="1.2em" fill="currentColor" viewBox="0 0 20 20">
              <path d="M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" />
              <path d="M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" />
            </svg>
          </Button>
        </InputRightAddon>
      </InputGroup>
    </VStack>
  );
}
